import api from '..'

const courseProgress = (courseId: number) => {
  return api.get(`courses/${courseId}/course_progress`)
}

export default courseProgress
